import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { AppLauncher, APP_LAUNCHER_MANIFEST } from '../AppLauncher'
import { createLauncherController } from './launcherController'
import styles from './AppLauncherHost.module.css'

export default function AppLauncherHost({ runtime, isOpen, onClose, returnFocusRef, navigationGuard }) {
  const [state, setState] = useState({ groups: [], status: 'idle', isLaunchPending: false })
  const controller = useRef(null)
  const [confirming, setConfirming] = useState(false)
  useEffect(() => {
    if (!isOpen || confirming) return
    document.body.classList.add(styles.active)
    return () => document.body.classList.remove(styles.active)
  }, [isOpen, confirming])
  useLayoutEffect(() => {
    const current = createLauncherController(runtime, APP_LAUNCHER_MANIFEST, setState, target => window.location.assign(target))
    controller.current = current
    return () => { current.dispose(); controller.current = null }
  }, [runtime])
  useLayoutEffect(() => {
    setConfirming(false)
    if (isOpen) controller.current.refresh()
    else controller.current.close()
  }, [isOpen, runtime])
  useEffect(() => {
    if (confirming && !navigationGuard) {
      controller.current.close()
      setConfirming(false)
      onClose()
    }
  }, [confirming, navigationGuard, onClose])
  const guard = navigationGuard ? action => {
    setConfirming(true)
    navigationGuard({
      onConfirm: () => { setConfirming(false); action.onConfirm() },
      onCancel: () => { setConfirming(false); action.onCancel() },
    })
  } : null
  return <AppLauncher {...state} isOpen={isOpen && !confirming} returnFocusRef={returnFocusRef}
    theme={document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'}
    onClose={() => { controller.current.close(); onClose() }} onRefresh={() => controller.current.refresh()}
    onViewAll={() => controller.current.requestViewAll(guard)}
    onLaunch={item => controller.current.requestLaunch(item.id, guard)}
    onRetryLaunch={() => controller.current.retry(guard)} />
}
